// Shared site content & data for Proactive Dental

export const CLINIC = {
  name: "Proactive Dental",
  phoneDisplay: "(07) 5433 1569",
  phoneRaw: "0754331569",
  email: "info@proactivedental.com.au",
  address: "Unit 25/115 Buckley Rd, Burpengary East QLD 4505",
  mapUrl:
    "https://www.google.com/maps/place/Proactive+Dental+Surgery+Burpengary/@-27.138241,152.979591,14z/data=!4m5!3m4!1s0x0:0xa6799061f31dd879!8m2!3d-27.1382414!4d152.979591",
  bookUrl: "https://proactivedental.com.au/book-online/",
  hours: [
    ["Mon – Thu", "8:30am – 7:30pm"],
    ["Friday", "8:30am – 5:30pm"],
    ["Saturday", "8:30am – 1:30pm"],
    ["Sunday", "Closed"],
  ],
};

export const IMAGES = {
  hero: "/clinic-hero.jpg",
  calmPatient:
    "https://images.unsplash.com/photo-1567516364473-233c4b6fcfbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dentist:
    "https://images.unsplash.com/photo-1662837625421-5fd8ed6131a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kids: "https://images.pexels.com/photos/8260438/pexels-photo-8260438.jpeg?auto=compress&cs=tinysrgb&w=1200",
  gallery: [
    "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1562337404-3044c84ac061?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1508002366005-75a695ee2d17?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.unsplash.com/photo-1567516364473-233c4b6fcfbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ],
};

export const SERVICES = [
  {
    title: "Dental Implants",
    desc: "Permanent, natural-looking replacements for missing teeth.",
    icon: "Anchor",
  },
  {
    title: "Cosmetic Veneers",
    desc: "Transform your smile with custom porcelain veneers.",
    icon: "Sparkles",
  },
  {
    title: "Teeth Whitening",
    desc: "Professional whitening for a brighter, confident smile.",
    icon: "Sun",
  },
  {
    title: "Orthodontics",
    desc: "Braces & clear aligners for straighter teeth.",
    icon: "AlignCenter",
  },
  {
    title: "Crowns & Bridges",
    desc: "Restore strength and form with same-day CEREC crowns.",
    icon: "Crown",
  },
  {
    title: "Wisdom Teeth",
    desc: "Gentle, expert wisdom tooth removal.",
    icon: "Stethoscope",
  },
  {
    title: "Root Canal Therapy",
    desc: "Save your natural tooth and end the pain.",
    icon: "HeartPulse",
  },
  {
    title: "Dentures",
    desc: "Comfortable, custom-fit full and partial dentures.",
    icon: "Smile",
  },
];

export const HEALTH_FUNDS = ["Bupa", "HCF", "Medibank", "HICAPS", "nib", "AGDVA"];

export const TRUST = [
  "Serving Burpengary since 2010",
  "5,000+ Happy Patients",
  "5-Star Google Rated",
  "Gentle, Anxiety-Free Care",
  "Meet Winston — Our Therapy Dog",
  "Free Kids Dental (CDBS)",
  "All Major Health Funds Accepted",
];
